var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaterTransparency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.219,
    height: 107.984,
    viewBox: "0 0 100.219 107.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(0 0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Soustraction_4",
    "data-name": "Soustraction 4",
    d: "M86.285,106.784H1.2a1.2,1.2,0,0,1-1.2-1.2V1.2A1.2,1.2,0,0,1,1.2,0H86.285a1.2,1.2,0,0,1,1.2,1.2V105.584A1.2,1.2,0,0,1,86.285,106.784ZM11.492,9.006a1.2,1.2,0,0,0-1.2,1.2V97.865a1.2,1.2,0,0,0,1.2,1.2H78.566a1.2,1.2,0,0,0,1.2-1.2V10.206a1.2,1.2,0,0,0-1.2-1.2Z",
    transform: "translate(7.72 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    opacity: 0.458
  }), /*#__PURE__*/React.createElement("g", {
    id: "flame",
    transform: "translate(23.167 72.047)",
    opacity: 0.458
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3.958,23.845A18.5,18.5,0,0,1,.786,19.361a10.168,10.168,0,0,1-.6-5.852A12.622,12.622,0,0,1,2.7,8.094a5.216,5.216,0,0,0,1.313,3.828A9.1,9.1,0,0,1,6.091,4.375,15.633,15.633,0,0,1,12.764,0a5.391,5.391,0,0,0-.93,5.141,21.436,21.436,0,0,0,2.461,4.868,10.864,10.864,0,0,1,1.86,5.032,17.589,17.589,0,0,0,1.367-2.9,5.727,5.727,0,0,0,.219-3.172,8.134,8.134,0,0,1,1.8,3.938,16.551,16.551,0,0,1,.055,4.649,11.626,11.626,0,0,1-1.586,4.868,9.133,9.133,0,0,1-4.758,3.555C9.865,26.58,6.529,26.088,3.958,23.845Z",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M3.613,14.821c4.485,1.75,8.915-3.555,6.454-7.657,0-.055-.055-.055-.055-.109.219,2.242-.328,3.883-1.367,4.813a5.108,5.108,0,0,0-.492-4.157C7.5,6.454,6.567,5.305,5.856,4.1A5.813,5.813,0,0,1,4.926,0,7.212,7.212,0,0,0,2.3,4.047,7.321,7.321,0,0,0,2.848,8.86,3.6,3.6,0,0,1,1.371,6.235,5.632,5.632,0,0,0,0,10.009,5.571,5.571,0,0,0,3.613,14.821Z",
    transform: "translate(4.501 11.048)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "drop",
    transform: "translate(61.786 73.334)",
    opacity: 0.458
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M9.265,8.5,9.26,8.492,4.883.057a.106.106,0,0,0-.187,0L.32,8.492.315,8.5a4.934,4.934,0,0,0,4.472,6.659h.006A4.934,4.934,0,0,0,9.265,8.5Z",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0 0.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M5.127,14.191A5.478,5.478,0,0,1,3.484,10.3a.111.111,0,0,1,0-.014L4.661,0,.32,8.367l-.005.012a4.934,4.934,0,0,0,4.472,6.659h.006a4.923,4.923,0,0,0,1.159-.175A5.575,5.575,0,0,1,5.127,14.191Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M4.672,4.228l-.005-.012L2.509.057a.106.106,0,0,0-.187,0L.164,4.216l-.005.012A2.486,2.486,0,0,0,2.412,7.583h.006A2.486,2.486,0,0,0,4.672,4.228Z",
    transform: "translate(11.367 6.414)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M3.112,4.228l-.005-.012L.949.057A.106.106,0,0,0,.855,0h0L0,4.94a.108.108,0,0,0,0,.014A2.745,2.745,0,0,0,1.432,7.5c.074-.02.148-.043.22-.07A2.49,2.49,0,0,0,3.112,4.228Z",
    transform: "translate(12.927 6.539)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M3.175,2.828,1.738.057a.106.106,0,0,0-.187,0L.112,2.828.107,2.84A1.692,1.692,0,0,0,1.641,5.123h.007A1.692,1.692,0,0,0,3.181,2.84Z",
    transform: "translate(8.562 14.509)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M2.163,2.84l-.005-.012L.72.057A.106.106,0,0,0,.626,0,.1.1,0,0,0,.594.006L0,3.478a.119.119,0,0,0,0,.014A1.911,1.911,0,0,0,.768,5.113a1.692,1.692,0,0,0,1.4-2.274Z",
    transform: "translate(9.579 14.509)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M0,0H40.057a4.825,4.825,0,0,1,4.825,4.825h0a4.825,4.825,0,0,1-4.825,4.825H28.426a4.513,4.513,0,0,0-4.513,4.513h0a4.513,4.513,0,0,0,4.513,4.513H52.105",
    transform: "translate(0 24.445)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    opacity: 0.458
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M0,0H25.676a4.5,4.5,0,0,1,4.5,4.5h0a4.5,4.5,0,0,1-4.5,4.5H10.706a4.5,4.5,0,0,0-4.5,4.5h0a4.5,4.5,0,0,0,4.5,4.5H48.113",
    transform: "translate(52.105 43.121)",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    opacity: 0.458
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M.5,55.294V0",
    transform: "translate(52.249 42.484)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    opacity: 0.458
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaterTransparency);
export default __webpack_public_path__ + "static/media/heater-transparency.b0f0212cf2fd3d93327e7090b7e69463.svg";
export { ForwardRef as ReactComponent };